/**
 * StochRSI — IFR Estocástico (Chande & Kroll).
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.StochRSI — idêntico no TradeZonePlatform):
 *
 *   RSI      = SMA(MAX(C-C₋₁,0),N,1) / SMA(|C-C₋₁|,N,1) · 100   (RSI SMA-chinesa)
 *   StochRSI = (RSI - LLV(RSI,N)) / (HHV(RSI,N) - LLV(RSI,N))
 *
 * Normaliza o RSI para [0,1] pela sua própria faixa numa janela de N. Usa o RSI
 * SMA-chinesa do engine (rsiSma em silverlightDsl.js), NÃO o rsi (Wilder) do
 * odin. Paridade numérica provada em __tests__/stochRsi.silverlight.test.js.
 */
import { rsiSma, hhv, llv, sub, div } from "./silverlightDsl";
import { StochRSI as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    const close = data.map((d) => d.close ?? NaN);
    const rsi = rsiSma(close, period);
    const lo = llv(rsi, period);
    const hi = hhv(rsi, period);
    // (RSI - LLV) / (HHV - LLV); janela plana → HHV==LLV → 0/0 = NaN → undefined
    const out = div(sub(rsi, lo), sub(hi, lo));

    return out.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    // warm-up do RSI (N-1) + warm-up do HHV/LLV sobre o RSI (N-1)
    return 2 * (period - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
